const FAVICON_SIZE = 64;
const CORNER_RATIO = 0.12;
/** Slightly larger than strict contain so the tab icon reads bigger. */
const SCALE_BOOST = 1.22;

function roundRectPath(ctx, x, y, w, h, radius) {
  const r = Math.min(radius, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

/** Fit full logo inside favicon (contain) with rounded corners — nothing cropped. */
export async function buildRoundedFaviconHref(src) {
  if (!src) return "";

  try {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.decoding = "async";

    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
      img.src = src;
    });

    const canvas = document.createElement("canvas");
    canvas.width = FAVICON_SIZE;
    canvas.height = FAVICON_SIZE;
    const ctx = canvas.getContext("2d");

    const scale =
      Math.min(FAVICON_SIZE / img.width, FAVICON_SIZE / img.height) *
      SCALE_BOOST;
    const w = img.width * scale;
    const h = img.height * scale;
    const x = (FAVICON_SIZE - w) / 2;
    const y = (FAVICON_SIZE - h) / 2;
    const radius = Math.min(w, h) * CORNER_RATIO;

    roundRectPath(ctx, x, y, w, h, radius);
    ctx.clip();
    ctx.drawImage(img, x, y, w, h);

    return canvas.toDataURL("image/png");
  } catch {
    return src;
  }
}
